module.exports = __webpack_public_path__ + "img/img72.f4188f70.svg";